module.exports = __webpack_public_path__ + "img/ring_r_0_null_0@2x.558bda71.png";